import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "mb-15" }
const _hoisted_2 = { style: {"text-align":"end"} }
const _hoisted_3 = { class: "panel-header panel-left" }
const _hoisted_4 = { class: "schedule-col name schedule-header-cell" }
const _hoisted_5 = {
  class: "panel-left",
  ref: "attendanceScheduleLeftPanel"
}
const _hoisted_6 = { class: "schedule-col name schedule-body-cell" }
const _hoisted_7 = { class: "schedule-col actions schedule-body-cell" }
const _hoisted_8 = {
  class: "panel-center",
  ref: "attendanceScheduleCenterPanel"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "mb-4" }
const _hoisted_13 = { class: "default-schedule-header" }
const _hoisted_14 = { class: "default-schedule-header-item d-flex" }
const _hoisted_15 = { class: "col-name d-flex align-center justify-center font-weight-bold" }
const _hoisted_16 = { class: "default-schedule" }
const _hoisted_17 = { class: "default-schedule-field d-flex" }
const _hoisted_18 = { class: "col-name" }
const _hoisted_19 = { class: "py-2" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "mb-4" }
const _hoisted_23 = { class: "mb-4" }
const _hoisted_24 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_25 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "mb-4" }
const _hoisted_30 = { class: "mb-4" }
const _hoisted_31 = { class: "mb-4" }
const _hoisted_32 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_33 = {
  key: 0,
  class: "my-2"
}
const _hoisted_34 = { class: "mb-4" }
const _hoisted_35 = { class: "mb-4" }
const _hoisted_36 = { class: "mb-4" }
const _hoisted_37 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_38 = {
  key: 0,
  class: "my-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_month_pager = _resolveComponent("month-pager")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_scrollable_panels_2 = _resolveComponent("scrollable-panels-2")!
  const _component_hour_minute_input = _resolveComponent("hour-minute-input")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_month_date_picker = _resolveComponent("month-date-picker")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card_title = _resolveComponent("v-card-title")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_btn, {
        variant: "outlined",
        color: "primary",
        class: "attendance-pattern-settings-btn",
        onClick: _ctx.openAddChildDefaultScheduleModal,
        loading: _ctx.isUpdatingSchedule || _ctx.isFetching
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.monthlyChild.buttons.patternSettings')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    _createVNode(_component_v_row, { class: "mb-4" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_month_pager, {
              class: "mr-4",
              modelValue: _ctx.yearMonth,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.yearMonth) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              variant: "flat",
              color: "primary",
              style: {"width":"200px","font-size":"0.8rem"},
              onClick: _ctx.addDefaultSchedules,
              disabled: _ctx.isUpdatingSchedule || _ctx.isFetching,
              loading: _ctx.isUpdatingSchedule || _ctx.isFetching
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.monthlyChild.buttons.bulkRegisterDefaults')), 1)
              ]),
              _: 1
            }, 8, ["onClick", "disabled", "loading"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_select, {
              filled: "",
              label: _ctx.$t('workScheduling.monthlyChild.filters.class'),
              density: "compact",
              items: _ctx.classes,
              "item-title": "className",
              "item-value": "classId",
              modelValue: _ctx.selectedClassId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedClassId) = $event)),
              clearable: "",
              color: "primary"
            }, null, 8, ["label", "items", "modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.isFetching)
      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
          key: 0,
          indeterminate: "",
          color: "primary",
          class: "my-4"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_scrollable_panels_2, { leftWidth: 280 }, {
        "left-panel-header": _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('workScheduling.monthlyChild.tableHeaders.childName')), 1)
          ])
        ]),
        "left-panel-body": _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduleTableRows, (schedule, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "schedule-row",
                key: `row-${i}`
              }, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(schedule.name), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_v_btn, {
                    size: "small",
                    block: "",
                    variant: "outlined",
                    color: "primary",
                    style: {"font-size":"0.7rem"},
                    onClick: ($event: any) => (_ctx.openBulkAddScheduleModal(schedule.child))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.monthlyChild.buttons.bulkRegister')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]))
            }), 128))
          ], 512)
        ]),
        "center-panel-header": _withCtx(() => [
          _createElementVNode("div", {
            class: "panel-header panel-center",
            style: _normalizeStyle(`width: ${_ctx.numberOfDates * 50}px; position: sticky; top: 0;`)
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableDates, (date) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "schedule-col date schedule-header-cell",
                key: date.label,
                style: _normalizeStyle(`${date.isSaturday ? 'color: blue;' : ''}${date.isSunday ? 'color: red;' : ''}`)
              }, _toDisplayString(date.label), 5))
            }), 128))
          ], 4)
        ]),
        "center-panel-body": _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduleTableRows, (schedule, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "schedule-row",
                key: `row-${i}`,
                style: _normalizeStyle({ width: `${_ctx.numberOfDates * 50}px` })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schedule.schedules, (s) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass([
                'schedule-col date',
              ]),
                    key: s.date
                  }, [
                    (s.status==='attending')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass([
                  'schedule-body-cell date',
                  s.status ? 'active' : ''
                ]),
                          style: _normalizeStyle(`background-color: ${s.color}; color: white; font-size: 12px; padding: 2px; font-weight: bold;`),
                          onClick: ($event: any) => (_ctx.openEditScheduleModal(schedule.child, s))
                        }, [
                          _createTextVNode(_toDisplayString(s.startMinFormatted), 1),
                          _cache[24] || (_cache[24] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode(" " + _toDisplayString(s.endMinFormatted), 1)
                        ], 14, _hoisted_9))
                      : _createCommentVNode("", true),
                    (s.status==='isAbsent')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass([
                  'schedule-body-cell date',
                  s.status ? 'active' : ''
                ]),
                          style: _normalizeStyle(`background-color: ${s.color}; color: white;`),
                          onClick: ($event: any) => (_ctx.openEditScheduleModal(schedule.child, s))
                        }, _toDisplayString(_ctx.$t('workScheduling.daily.statusIndicators.absent')), 15, _hoisted_10))
                      : _createCommentVNode("", true),
                    (s.status==null)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: "schedule-body-cell date add",
                          onClick: ($event: any) => (_ctx.openAddScheduleModal(schedule.child, s.date))
                        }, [
                          _createVNode(_component_v_icon, {
                            small: "",
                            color: "#d0d0d0"
                          }, {
                            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                              _createTextVNode("mdi-plus", -1)
                            ]))]),
                            _: 1
                          })
                        ], 8, _hoisted_11))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ], 4))
            }), 128))
          ], 512)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_v_dialog, {
      "max-width": "1080px",
      modelValue: _ctx.isAddChildDefaultScheduleModalOpen,
      "onUpdate:modelValue": [
        _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isAddChildDefaultScheduleModalOpen) = $event)),
        _ctx.isAddChildDefaultScheduleModalClose
      ]
    }, {
      default: _withCtx(() => [
        (_ctx.bulkAddingSchedule)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "py-4 scrollable-content" }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('workScheduling.monthlyChild.defaultSchedule.title')), 1),
                    _createVNode(_component_v_row, { class: "ml-4 mb-6" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('workScheduling.monthlyChild.labels.checkInTime')), 1),
                          _createVNode(_component_hour_minute_input, {
                            class: "mb-4",
                            modelValue: _ctx.bulkDefaultMin.startMin,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bulkDefaultMin.startMin) = $event))
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('workScheduling.monthlyChild.labels.checkOutTime')), 1),
                          _createVNode(_component_hour_minute_input, {
                            modelValue: _ctx.bulkDefaultMin.endMin,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bulkDefaultMin.endMin) = $event))
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      _: 1
                    }),
                    (_ctx.isFetching)
                      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                          key: 0,
                          indeterminate: "",
                          color: "primary",
                          class: "my-4"
                        }))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t(_ctx.header.names)), 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.header.dayOfWeek), (key) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: key,
                                  class: "col-day d-flex flex-column align-center justify-center font-weight-bold"
                                }, [
                                  _createTextVNode(_toDisplayString(_ctx.$t(_ctx.header.dayOfWeek[key])) + " ", 1),
                                  _createVNode(_component_v_checkbox, {
                                    class: "default-schedule-header-checkbox mt-1",
                                    "model-value": _ctx.defaultScheduleSelected[key],
                                    "onUpdate:modelValue": val => { _ctx.defaultScheduleSelected[key] = val === true; _ctx.toggeleAll(key); },
                                    "hide-details": "",
                                    density: "compact",
                                    color: "primary"
                                  }, null, 8, ["model-value", "onUpdate:modelValue"])
                                ]))
                              }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduleTableRows, (schedule, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "default-schedule-body d-flex flex-column align-center justify-center",
                                    key: i
                                  }, [
                                    _createElementVNode("div", _hoisted_19, _toDisplayString(schedule.name), 1),
                                    _cache[26] || (_cache[26] = _createElementVNode("div", { style: {"height":"24px"} }, null, -1)),
                                    _cache[27] || (_cache[27] = _createElementVNode("div", { style: {"width":"100%","border-top":"solid 1px grey"} }, null, -1))
                                  ]))
                                }), 128))
                              ]),
                              _createElementVNode("div", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.defaultScheduleItems, (items) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "default-schedule-body-items d-flex",
                                    key: items.childId
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.days, (dayValue, dayKey) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "col-day default-schedule-item d-flex flex-column justify-center align-center",
                                        key: `${items.childId}-${dayKey}`
                                      }, [
                                        _createVNode(_component_v_checkbox, {
                                          "model-value": items.days[dayKey],
                                          "onUpdate:modelValue": ($event: any) => (items.days[dayKey] = $event === true),
                                          "hide-details": "",
                                          density: "compact",
                                          color: "primary"
                                        }, null, 8, ["model-value", "onUpdate:modelValue"]),
                                        (items.defaultMin[dayKey].startMin && items.defaultMin[dayKey].endMin)
                                          ? (_openBlock(), _createElementBlock("label", _hoisted_20, _toDisplayString(`${String(Math.trunc(items.defaultMin[dayKey].startMin / 60)).padStart(2, '0')}:${String(items.defaultMin[dayKey].startMin % 60).padStart(2, '0')}
                      - ${String(Math.trunc(items.defaultMin[dayKey].endMin / 60)).padStart(2, '0')}:${String(items.defaultMin[dayKey].endMin % 60).padStart(2, '0')}`), 1))
                                          : (_openBlock(), _createElementBlock("label", _hoisted_21, " - ")),
                                        _cache[28] || (_cache[28] = _createElementVNode("div", { style: {"width":"100%","border-top":"solid 1px grey"} }, null, -1))
                                      ]))
                                    }), 128))
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ], 64)),
                    _createVNode(_component_v_row, { class: "mb-4 mt-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "default-schedule-btn-delete text-center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              variant: "flat",
                              color: "red",
                              style: {"color":"white"},
                              onClick: _ctx.deleteChildDefaultSchedule,
                              disabled: _ctx.isUpdatingSchedule || _ctx.isFetching,
                              loading: _ctx.isUpdatingSchedule || _ctx.isFetching
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.monthlyChild.defaultSchedule.deleteSelection')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled", "loading"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, { class: "default-schedule-btn-save text-center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              variant: "flat",
                              color: "primary",
                              style: {"color":"white"},
                              onClick: _ctx.saveChildDefaultSchedule,
                              disabled: _ctx.isUpdatingSchedule || _ctx.isFetching,
                              loading: _ctx.isUpdatingSchedule || _ctx.isFetching
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick", "disabled", "loading"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onUpdate:modelValue"]),
    _createVNode(_component_v_dialog, {
      "max-width": "1080px",
      modelValue: _ctx.isBulkAddScheduleModalOpen,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isBulkAddScheduleModalOpen) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.bulkAddingSchedule && _ctx.bulkAddingUser)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "py-4" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('children.childName')), 1),
                              _createElementVNode("h3", null, _toDisplayString(_ctx.bulkAddingUser.lastName) + " " + _toDisplayString(_ctx.bulkAddingUser.firstName), 1)
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('workScheduling.daily.attendanceStatus')), 1),
                              _createVNode(_component_v_select, {
                                variant: "outlined",
                                items: _ctx.absenseOptions,
                                "item-title": "title",
                                "item-value": "value",
                                modelValue: _ctx.bulkAddingSchedule.status,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.bulkAddingSchedule.status) = $event)),
                                color: "primary"
                              }, null, 8, ["items", "modelValue"])
                            ]),
                            (_ctx.bulkAddingSchedule.status === 'attending')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t('workScheduling.monthlyChild.labels.checkInTime')), 1),
                                  _createVNode(_component_hour_minute_input, {
                                    class: "mb-4",
                                    modelValue: _ctx.bulkAddingSchedule.startMin,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bulkAddingSchedule.startMin) = $event))
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t('workScheduling.monthlyChild.labels.checkOutTime')), 1),
                                  _createVNode(_component_hour_minute_input, {
                                    modelValue: _ctx.bulkAddingSchedule.endMin,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.bulkAddingSchedule.endMin) = $event))
                                  }, null, 8, ["modelValue"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.bulkAddingSchedule.status === 'isAbsent')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t('workScheduling.daily.absenceReason')), 1),
                                  _createVNode(_component_v_select, {
                                    variant: "outlined",
                                    items: _ctx.absenseReasons,
                                    "item-title": "title",
                                    "item-value": "value",
                                    modelValue: _ctx.bulkAddingSchedule.statusReason,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.bulkAddingSchedule.statusReason) = $event)),
                                    color: "primary"
                                  }, null, 8, ["items", "modelValue"]),
                                  (_ctx.bulkAddingSchedule.statusReason === 'others')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                        _createVNode(_component_v_textarea, {
                                          label: _ctx.$t('workScheduling.daily.commentRequired'),
                                          modelValue: _ctx.bulkAddingSchedule.statusComment,
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.bulkAddingSchedule.statusComment) = $event)),
                                          color: "primary"
                                        }, null, 8, ["label", "modelValue"])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_month_date_picker, {
                              modelValue: _ctx.bulkAddingSchedule.dates,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.bulkAddingSchedule.dates) = $event)),
                              "year-month": _ctx.yearMonth
                            }, {
                              date: _withCtx(({date}) => [
                                _createElementVNode("div", {
                                  class: _normalizeClass([
                    'month-date-picker-cell'
                  ]),
                                  style: _normalizeStyle(`background-color: ${_ctx.getRegisteredSchedule(date) ? _ctx.getRegisteredSchedule(date)?.color : null}`)
                                }, [
                                  (_ctx.getRegisteredSchedule(date)?.status === 'attending')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t('workScheduling.daily.statusIndicators.present')), 1))
                                    : (_ctx.getRegisteredSchedule(date)?.status === 'isAbsent')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('workScheduling.daily.statusIndicators.absent')), 1))
                                      : _createCommentVNode("", true)
                                ], 4)
                              ]),
                              _: 1
                            }, 8, ["modelValue", "year-month"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      color: "primary",
                      class: "mx-2",
                      onClick: _ctx.addBulkSchedule
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                (_ctx.isUpdatingSchedule)
                  ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                      key: 0,
                      indeterminate: "",
                      color: "primary"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      "max-width": "1080px",
      modelValue: _ctx.isAddScheduleModalOpen,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.isAddScheduleModalOpen) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.addingUser && _ctx.addingDate && _ctx.addingSchedule)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.monthlyChild.modals.addTitle')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "mb-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('children.childName')), 1),
                              _createElementVNode("h3", null, _toDisplayString(_ctx.addingUser.lastName) + " " + _toDisplayString(_ctx.addingUser.firstName), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('common.date')), 1),
                              _createElementVNode("h3", null, _toDisplayString(_ctx.addingDate), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { class: "mb-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('workScheduling.daily.attendanceStatus')), 1),
                              _createVNode(_component_v_select, {
                                variant: "outlined",
                                items: _ctx.absenseOptions,
                                modelValue: _ctx.addingSchedule.status,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.addingSchedule.status) = $event)),
                                color: "primary"
                              }, null, 8, ["items", "modelValue"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col)
                      ]),
                      _: 1
                    }),
                    (_ctx.addingSchedule.status === 'isAbsent')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('workScheduling.daily.absenceReason')), 1),
                          _createVNode(_component_v_select, {
                            variant: "outlined",
                            items: _ctx.absenseReasons,
                            modelValue: _ctx.addingSchedule.statusReason,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.addingSchedule.statusReason) = $event)),
                            color: "primary"
                          }, null, 8, ["items", "modelValue"]),
                          (_ctx.addingSchedule.statusReason === 'others')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                _createVNode(_component_v_textarea, {
                                  label: _ctx.$t('workScheduling.daily.commentRequired'),
                                  modelValue: _ctx.addingSchedule.statusComment,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.addingSchedule.statusComment) = $event)),
                                  color: "primary"
                                }, null, 8, ["label", "modelValue"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.addingSchedule.status === 'attending')
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 1,
                          class: "mb-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('workScheduling.monthlyChild.labels.checkInTime')), 1),
                                _createVNode(_component_hour_minute_input, {
                                  modelValue: _ctx.addingSchedule.startMin,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.addingSchedule.startMin) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('workScheduling.monthlyChild.labels.checkOutTime')), 1),
                                _createVNode(_component_hour_minute_input, {
                                  modelValue: _ctx.addingSchedule.endMin,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.addingSchedule.endMin) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      color: "primary",
                      class: "mx-2",
                      onClick: _ctx.addSchedule
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                (_ctx.isUpdatingSchedule)
                  ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                      key: 0,
                      indeterminate: "",
                      color: "primary"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      "max-width": "1080px",
      modelValue: _ctx.isEditScheduleModalOpen,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.isEditScheduleModalOpen) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.editingSchedule && _ctx.editingUser)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('workScheduling.monthlyChild.modals.editTitle')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "mb-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('children.childName')), 1),
                              _createElementVNode("h3", null, _toDisplayString(_ctx.editingUser.lastName) + " " + _toDisplayString(_ctx.editingUser.firstName), 1)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('common.date')), 1),
                              _createElementVNode("h3", null, _toDisplayString(_ctx.dayjs(_ctx.editingSchedule.date).format('DD-MM-YYYY')), 1)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { class: "mb-4" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("h4", null, _toDisplayString(_ctx.$t('workScheduling.daily.attendanceStatus')), 1),
                              _createVNode(_component_v_select, {
                                variant: "outlined",
                                items: _ctx.absenseOptions,
                                modelValue: _ctx.editingSchedule.status,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.editingSchedule.status) = $event)),
                                color: "primary"
                              }, null, 8, ["items", "modelValue"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col)
                      ]),
                      _: 1
                    }),
                    (_ctx.editingSchedule.status === 'isAbsent')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('workScheduling.daily.absenceReason')), 1),
                          _createVNode(_component_v_select, {
                            variant: "outlined",
                            items: _ctx.absenseReasons,
                            modelValue: _ctx.editingSchedule.statusReason,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.editingSchedule.statusReason) = $event)),
                            color: "primary"
                          }, null, 8, ["items", "modelValue"]),
                          (_ctx.editingSchedule.statusReason === 'others')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                _createVNode(_component_v_textarea, {
                                  label: _ctx.$t('workScheduling.daily.commentRequired'),
                                  modelValue: _ctx.editingSchedule.statusComment,
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.editingSchedule.statusComment) = $event)),
                                  color: "primary"
                                }, null, 8, ["label", "modelValue"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.editingSchedule.status === 'attending')
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 1,
                          class: "mb-4"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('workScheduling.monthlyChild.labels.checkInTime')), 1),
                                _createVNode(_component_hour_minute_input, {
                                  modelValue: _ctx.editingSchedule.startMin,
                                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.editingSchedule.startMin) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('workScheduling.monthlyChild.labels.checkOutTime')), 1),
                                _createVNode(_component_hour_minute_input, {
                                  modelValue: _ctx.editingSchedule.endMin,
                                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.editingSchedule.endMin) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, { class: "justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      color: "red",
                      dark: "",
                      class: "mx-4",
                      onClick: _ctx.deleteEditingShcedule
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_v_btn, {
                      variant: "flat",
                      color: "primary",
                      class: "mx-4",
                      onClick: _ctx.saveEditingShcedule
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                (_ctx.isUpdatingSchedule)
                  ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                      key: 0,
                      indeterminate: "",
                      color: "primary"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}